export interface AppPage {
  permissao: string;
  route: string;
}

// Páginas de primeiro nível navegáveis por permissão - mantido em sincronia
// com as rotas protegidas por permissionGuard em app.routes.ts. Usado pelo
// landingGuard para decidir a tela inicial do usuário (ex.: quando o usuário
// só tem acesso a uma única página, cair direto nela).
export const APP_PAGES: AppPage[] = [
  { permissao: 'Dashboard', route: '/dashboard' },
  { permissao: 'DashboardTec', route: '/dashboard-tec' },
  { permissao: 'Empreendimentos', route: '/empreendimentos' },
  { permissao: 'Investidores', route: '/empresa' },
  { permissao: 'Operacoes', route: '/operacoes/empreendimento' },
  { permissao: 'EspelhoVendas', route: '/operacoes/espelho-vendas' },
  { permissao: 'Extrator', route: '/extrator/empreendimento' },
  { permissao: 'NovasConversoes', route: '/mapeamento/novas-conversoes' },
  { permissao: 'ValidacaoParsers', route: '/mapeamento/validacao-regras' },
  { permissao: 'Log', route: '/logs' },
  { permissao: 'GerenciamentoVinculos', route: '/vinculos' },
  { permissao: 'Usuarios', route: '/usuarios' },
  { permissao: 'Empreendimentos', route: '/cadastro-operacoes' },
  { permissao: 'Empreendimentos', route: '/cadastro-contas' },
  { permissao: 'GerenciarAcesso', route: '/perfil' },
  { permissao: 'GerenciarAcesso', route: '/permissoes' },
  { permissao: 'GerenciarAcesso', route: '/sessoes-operacao' },
  { permissao: 'AuditorContrato', route: '/auditor-contrato' },
  { permissao: 'ArquivosNaoMapeados', route: '/extratos-bancarios-nao-identificados' },
  { permissao: 'AuditorFiscal', route: '/engenharia/auditor-fiscal' },
  { permissao: 'ContasPagas', route: '/engenharia/contas-pagas' },
  { permissao: 'ConciliadorNotas', route: '/engenharia/conciliador-notas' },
  { permissao: 'MonitorObrasUpload', route: '/monitor-obras/upload-arquivos' },
  { permissao: 'MonitorObrasConsulta', route: '/monitor-obras/consulta' },
  { permissao: 'ImportacaoBRM', route: '/importacao/importar-brm' },
  { permissao: 'VistoMob', route: '/vistomob/medicoes' },
  { permissao: 'VistoMob', route: '/vistomob/cenarios' },
  { permissao: 'VistoMob', route: '/vistomob/vistoriadores' },
  { permissao: 'UsuariosExternos', route: '/api-externa/usuarios' },
  { permissao: 'ConsumoApiExterna', route: '/api-externa/consumo' },
  { permissao: 'UsuariosExternos', route: '/api-externa/documentacao' }
];
